// auth.js
export const logoutAndRedirect = () => {
  // prevent multiple redirects
  if (sessionStorage.getItem("redirected")) return;

  sessionStorage.setItem("redirected", "true");

  localStorage.removeItem("auth_token");

  // redirect to token page
  window.location.href = "/";
};
